Namespace('Settings.Views.ChatbotConfiguration')

class Settings.Views.ChatbotConfiguration.IntentPlaceholderRowView extends Backbone.View
  template: JST["backbone/templates/settings/chatbot_configuration/intents_table_placeholder_row"]
  tagName: 'tr'

  render: =>
    @$el.html(@template())
    @_adjustPlaceholders()
    @

  _adjustPlaceholders: =>
    @$el.find('#name-placeholder').css('width', "#{@_namePlaceholderWidth()}px")
    @$el.find('#description-placeholder').css('width', "#{@_descriptionPlaceholderWidth()}px")
    @$el.find('#last-updated-placeholder').css('width', "#{@_lastUpdatedPlaceholderWidth()}px")
    @$el.find('#edited-by-placeholder').css('width', "#{@_editedByPlaceholderWidth()}px")
    @$el.find('#actions-placeholder').css('width', "#{@_actionsPlaceholderWidth()}px")
    @$el.find('#reason-placeholder').css('width', "#{@_reasonPlaceholderWidth()}px")


  _namePlaceholderWidth: =>
    @_randomNumberInRange(65, 130)

  _descriptionPlaceholderWidth: =>
    @_randomNumberInRange(100, 230)

  _lastUpdatedPlaceholderWidth: =>
    70

  _editedByPlaceholderWidth: =>
    @_randomNumberInRange(65, 130)

  _actionsPlaceholderWidth: =>
    150

  _reasonPlaceholderWidth: =>
    @_randomNumberInRange(150, 330)

  _randomNumberInRange: (lower, upper) ->
    Math.floor(Math.random() * (upper - lower + 1) + lower)
